/** @typedef {'Monday'|'Tuesday'|'Wednesday'|'Thursday'|'Friday'} Weekday */

const ANCHOR_SLOTS_EY = [
  { id: 'arrival', label: 'Arrival / free flow', kind: 'anchor', order: 1, durationMins: 20, acceptsCategories: ['arrival_free_flow'], notes: 'Same activity every day' },
  { id: 'registration', label: 'Registration (tactile / welcome song)', kind: 'anchor', order: 2, durationMins: 15, acceptsCategories: ['registration'], notes: 'Same activity every day' },
  { id: 'morning_literacy', label: 'Morning learning block', kind: 'anchor', order: 3, durationMins: 25, acceptsCategories: ['morning_literacy'], notes: 'Same activity every day' },
  { id: 'early_numeracy', label: 'Early numeracy block', kind: 'anchor', order: 4, durationMins: 20, acceptsCategories: ['early_numeracy'], notes: 'Same activity every day' },
  { id: 'snack', label: 'Snack (embedded communication)', kind: 'anchor', order: 5, durationMins: 15, acceptsCategories: ['snack_communication'], notes: 'Same activity every day' },
  { id: 'afternoon_sensory', label: 'Afternoon sensory / regulation', kind: 'anchor', order: 6, durationMins: 20, acceptsCategories: ['afternoon_sensory'], notes: 'Same activity every day' },
  { id: 'story_calm', label: 'Story / calm time', kind: 'anchor', order: 7, durationMins: 15, acceptsCategories: ['story_calm'], notes: 'Same activity every day' },
  { id: 'end_of_day', label: 'End-of-day routine', kind: 'anchor', order: 8, durationMins: 10, acceptsCategories: ['end_of_day'], notes: 'Same activity every day' },
];

const VARIABLE_SLOTS_EY = [
  { id: 'bucket_time', label: 'Bucket time', kind: 'variable', order: 9, durationMins: 15, acceptsCategories: ['bucket_time'], defaultDays: ['Monday', 'Wednesday', 'Friday'] },
  { id: 'intervention_block', label: 'Focused intervention', kind: 'variable', order: 10, durationMins: 20, acceptsCategories: ['focused_intervention'], defaultDays: ['Tuesday', 'Thursday'] },
];

const ANCHOR_SLOTS_ENGAGEMENT = [
  { id: 'arrival', label: 'Arrival / free flow', kind: 'anchor', order: 1, durationMins: 30, acceptsCategories: ['arrival_free_flow', 'cause_effect_play', 'intensive_interaction'], notes: 'Extended exploration; same every day' },
  { id: 'registration', label: 'Welcome / regulation', kind: 'anchor', order: 2, durationMins: 15, acceptsCategories: ['registration', 'afternoon_sensory'], notes: 'Same activity every day' },
  { id: 'sensory_learning', label: 'Sensory learning block', kind: 'anchor', order: 3, durationMins: 25, acceptsCategories: ['afternoon_sensory', 'cause_effect_play', 'intensive_interaction'], notes: 'Same activity every day' },
  { id: 'snack', label: 'Snack (communication embedded)', kind: 'anchor', order: 4, durationMins: 15, acceptsCategories: ['snack_communication'], notes: 'Same activity every day' },
  { id: 'afternoon_sensory', label: 'Afternoon regulation', kind: 'anchor', order: 5, durationMins: 25, acceptsCategories: ['afternoon_sensory', 'arrival_free_flow'], notes: 'Same activity every day' },
  { id: 'story_calm', label: 'Calm / sensory story', kind: 'anchor', order: 6, durationMins: 15, acceptsCategories: ['story_calm'], notes: 'Same activity every day' },
  { id: 'end_of_day', label: 'End-of-day routine', kind: 'anchor', order: 7, durationMins: 10, acceptsCategories: ['end_of_day'], notes: 'Same activity every day' },
];

const VARIABLE_SLOTS_ENGAGEMENT = [
  { id: 'intensive_interaction', label: 'Intensive interaction', kind: 'variable', order: 8, durationMins: 20, acceptsCategories: ['intensive_interaction', 'cause_effect_play'], defaultDays: ['Monday', 'Wednesday'] },
  { id: 'bucket_time', label: 'Bucket time', kind: 'variable', order: 9, durationMins: 15, acceptsCategories: ['bucket_time'], defaultDays: ['Tuesday', 'Friday'] },
];

const ANCHOR_SLOTS_KS1 = [
  { id: 'arrival', label: 'Arrival / settling', kind: 'anchor', order: 1, durationMins: 15, acceptsCategories: ['arrival_free_flow'], notes: 'Same activity every day' },
  { id: 'registration', label: 'Registration', kind: 'anchor', order: 2, durationMins: 15, acceptsCategories: ['registration'], notes: 'Same activity every day' },
  { id: 'morning_literacy', label: 'Literacy / phonics block', kind: 'anchor', order: 3, durationMins: 30, acceptsCategories: ['morning_literacy'], notes: 'Same activity every day' },
  { id: 'early_numeracy', label: 'Early numeracy block', kind: 'anchor', order: 4, durationMins: 25, acceptsCategories: ['early_numeracy'], notes: 'Same activity every day' },
  { id: 'snack', label: 'Snack (embedded communication)', kind: 'anchor', order: 5, durationMins: 15, acceptsCategories: ['snack_communication'], notes: 'Same activity every day' },
  { id: 'afternoon_sensory', label: 'Afternoon sensory / regulation', kind: 'anchor', order: 6, durationMins: 20, acceptsCategories: ['afternoon_sensory'], notes: 'Same activity every day' },
  { id: 'story_calm', label: 'Story / calm time', kind: 'anchor', order: 7, durationMins: 15, acceptsCategories: ['story_calm'], notes: 'Same activity every day' },
  { id: 'end_of_day', label: 'End-of-day routine', kind: 'anchor', order: 8, durationMins: 10, acceptsCategories: ['end_of_day'], notes: 'Same activity every day' },
];

const VARIABLE_SLOTS_KS1 = [
  { id: 'bucket_time', label: 'Bucket time', kind: 'variable', order: 9, durationMins: 15, acceptsCategories: ['bucket_time'], defaultDays: ['Monday', 'Wednesday', 'Friday'] },
  { id: 'paired_reading', label: 'Paired / small-group reading', kind: 'variable', order: 10, durationMins: 20, acceptsCategories: ['morning_literacy', 'focused_intervention'], defaultDays: ['Tuesday', 'Thursday'] },
];

export const CURRICULUM_RHYTHM_TEMPLATES = [
  {
    id: 'early_years_pre_formal',
    label: 'Early Years / pre-formal',
    description: 'Predictable daily routine with learning embedded across the day.',
    attainmentBands: ['pre-formal'],
    slots: [...ANCHOR_SLOTS_EY, ...VARIABLE_SLOTS_EY],
  },
  {
    id: 'ks1_send',
    label: 'Key Stage 1 SEND',
    description: 'Stable KS1 routine with small weekly variations for interventions.',
    attainmentBands: ['semi-formal'],
    slots: [...ANCHOR_SLOTS_KS1, ...VARIABLE_SLOTS_KS1],
  },
  {
    id: 'engagement_model',
    label: 'Engagement model',
    description: 'Extended sensory and interaction-led routine for pupils with brief engagement.',
    attainmentBands: ['pre-formal'],
    slots: [...ANCHOR_SLOTS_ENGAGEMENT, ...VARIABLE_SLOTS_ENGAGEMENT],
  },
];

export const WEEKDAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

const ENGAGEMENT_COG_VALUES = new Set([
  'brief_engagement',
  'concrete_only',
  'refuses_tasks',
  'distressed_tasks',
]);

export function getTemplateById(id) {
  return CURRICULUM_RHYTHM_TEMPLATES.find((t) => t.id === id);
}

export function selectRhythmTemplate(ncStatus, answers, ageYears) {
  const cog = answers?.cog_learning;
  const cogTasks = answers?.cog_structured_tasks;
  const isEngagement =
    ncStatus === 'four_or_more_below' &&
    (ENGAGEMENT_COG_VALUES.has(cog || '') || ENGAGEMENT_COG_VALUES.has(cogTasks || ''));

  if (isEngagement) return getTemplateById('engagement_model');
  if (ncStatus === 'two_to_three_below') return getTemplateById('ks1_send');
  return getTemplateById('early_years_pre_formal');
}

export function calculateAgeYears(dob) {
  if (!dob) return 7;
  const birth = new Date(dob);
  const now = new Date();
  return Math.floor((now.getTime() - birth.getTime()) / (365.25 * 24 * 60 * 60 * 1000));
}
